import { useRef } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import styled from 'styled-components';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import { API_URL } from '../../../../utils/constants';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import PurchaseOrderDropDown from '../components/PurchaseOrderDropDown';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function InventoryForPurchaseOrder(): JSX.Element {
  const { id } = useParams();
  const history = useHistory();
  const stateRef = useRef(null);
  const isValidId = id && id !== 'none';
  const url = `${API_URL}/inventory/get-grid-for-purchase-order/${id}`;
  const StatefullGrid = withState(Grid, isValidId ? url : null);

  const barcodeCell = (row: any): JSX.Element => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/inventory/list-for-generic/${dataItem.product.genericProductId}`}>
          <b>CU:</b>
          {dataItem.cuGtin}
          {', '}
          <b>DU:</b>
          {dataItem.duGtin}
        </Link>
      </td>
    );
  };

  const productNameCell = (row: any): JSX.Element => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/inventory/list-for-generic/${dataItem.product.genericProductId}`}>
          {dataItem.product.genericProduct.name}
        </Link>
      </td>
    );
  };
  
  const unitsCell = (row: any): JSX.Element => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/inventory/list-for-generic/${dataItem.product.genericProductId}`}>
          {`${dataItem.fullDuUnits}/${dataItem.singleDpUnits}/${dataItem.singleCuUnits}`}
        </Link>
      </td>
    );
  };

  return (
    <WhitePad isFluid>
      <TitleComponent onLeftHandler={history.goBack} titleLeft="Back" title="For Purchase Order" />
      <PurchaseOrderDropDown />
      <SubTitle>Current Stock</SubTitle>
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="name" title="Product Name" cell={productNameCell} filterable={false} />
          <GridColumn field="gtin" title="Barcode" cell={barcodeCell} filterable={false} />
          <GridColumn field="totalCuUnits" title="Total Units" filterable={false} />
          <GridColumn field="fullDuUnits" title="Full Boxes" cell={unitsCell} filterable={false} />
          <GridColumn field="expirationDate" title="Expiration Date" filterable={false} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}

const SubTitle = styled.h3`
  color: #a7a7a7;
  font-size: 25px;
  font-weight: 700;
  margin: 0;
  line-height: 29px;
`;
